import { GridStateFactory } from '@b2b/common/factories/gridState/types';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

OrgSearchDirective.$inject = [];
function OrgSearchDirective() {
  OrgSearchController.$inject = ['$scope', 'ApiService', 'GridStateFactory'];
  function OrgSearchController(
    $scope: IScope & { orgSearch: TODO; boxIndex: TODO; selectedOrg: TODO | null },
    ApiService: ApiService,
    GridStateFactory: GridStateFactory,
  ) {
    const ctrl = {
      comboboxIndex: 0,
      comboboxName: '',

      comboboxSelectedOrganization: null as TODO | null,

      comboboxOrganizations: [] as TODO[],

      organizationsGridState: new GridStateFactory(),
      organizationsPageSize: 10,

      waitTime: 500,

      init: function () {
        ctrl.comboboxIndex = $scope.boxIndex || 1;
        ctrl.comboboxName = 'org-search-' + ctrl.comboboxIndex;
      },

      comboboxSearchOrganizations: function (search: string) {
        const props = {
          ...ctrl.organizationsGridState.getGridState(),
          pageSize: ctrl.organizationsPageSize,
          organizationName: search,
          sortField: 'organizationName',
          sortDirection: 'asc',
        };

        ApiService.organizations.searchOrganizations(props).then((res) => {
          ctrl.comboboxOrganizations = res.data.payload.list.map((item) => {
            item.id = item.organizationId;
            item.name = item.organizationName;
            return item;
          });

          $scope.$broadcast('CustomTypeahead::FilterResults', { field: 'combobox-input-' + ctrl.comboboxName });
        });
      },

      onComboboxOrganizationChange: function () {
        $scope.selectedOrg = ctrl.comboboxSelectedOrganization;
      },
    };

    $scope.orgSearch = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/orgSearch/orgSearch.tpl.html',
    scope: {
      comboboxIndex: '=',
      selectedOrg: '=',
    },

    link: function ($scope, $element, $attrs) {
      // Modified after controller runs
    },

    controller: OrgSearchController,
  };
}

export const OrgSearchDirectiveModule = angular
  .module('acme.common.directive.orgSearch', ['acme.common.service.api', 'acme.common.factory.gridState'])
  .directive('orgSearch', OrgSearchDirective).name;
